import React, { useEffect, useState } from "react";
import { connect } from 'react-redux';
import { checkedChecklist, uncheckedChecklist, onloadDatafetching } from '../../redux/modules/checklist';
import { useRef } from "react";
import styles from "./ModuleChecklist.module.scss";
import RichTextParser from "../RichTextParser";
import ReactMarkdown from 'react-markdown';

const mapStateToProps = (state) => {
  const {
    user: { firstName, lastInitial, id },
    checklist: { checklistItems }
  } = state;

  return {
    firstName,
    lastInitial,
    id,
    checklistItems,
  };
};

const mapDispatchToProps = {
  checkedUser: checkedChecklist,
  uncheckedUser: uncheckedChecklist
};
function ModulEachChecklist({ _id, headerText, summaryText, summaryRichText, key, index, id, checklistItems, checkedUser, uncheckedUser, itemchecked, loadData}) {

  const [checkState, setCheckState] = useState(true)

  const handleCheckboxClick = (e, id, _id) => {
    if (id) {
      setCheckState(false)
      checkedUser(id, _id)

    }
    else {
      setCheckState(false)
    }
  }
const handleCheckbox1Click = (e, id, _id) => {
    if (id) {
      setCheckState(true)
      uncheckedUser(id, _id)
    }
    else {
      setCheckState(true)
    }
  }


  return (
    <div className={styles.parentContainer}>
      <div className={styles.checklistContainer}>

        {Object.keys(checklistItems).length > 0 && Object.entries(checklistItems?.items).length > 0 ?

          checklistItems?.items[_id] ?
            <div onClick={(e) => handleCheckbox1Click(e, id, _id)} id={`checkedSVG_${index}`}>
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 4C0 1.79086 1.79086 0 4 0H16C18.2091 0 20 1.79086 20 4V16C20 18.2091 18.2091 20 16 20H4C1.79086 20 0 18.2091 0 16V4Z" fill="#1A1918" />
                <path d="M5 10L8.5 13.5L15 7" stroke="#F2F7FF" strokeWidth="2" />
              </svg>
            </div>

            :
            <div onClick={(e) => handleCheckboxClick(e, id, _id)} id={`uncheckedSVG_${index}`} >
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4 0.5H16C17.933 0.5 19.5 2.067 19.5 4V16C19.5 17.933 17.933 19.5 16 19.5H4C2.067 19.5 0.5 17.933 0.5 16V4C0.5 2.067 2.067 0.5 4 0.5Z" stroke="#1A1918" />
              </svg>
            </div>

          :
          <> {(checkState ?
            <div onClick={(e) => handleCheckboxClick(e, id, _id)} id={`uncheckedSVG_${index}`} >
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4 0.5H16C17.933 0.5 19.5 2.067 19.5 4V16C19.5 17.933 17.933 19.5 16 19.5H4C2.067 19.5 0.5 17.933 0.5 16V4C0.5 2.067 2.067 0.5 4 0.5Z" stroke="#1A1918" />
              </svg>
            </div> :
            <div onClick={(e) => handleCheckbox1Click(e, id, _id)} id={`checkedSVG_${index}`}>
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 4C0 1.79086 1.79086 0 4 0H16C18.2091 0 20 1.79086 20 4V16C20 18.2091 18.2091 20 16 20H4C1.79086 20 0 18.2091 0 16V4Z" fill="#1A1918" />
                <path d="M5 10L8.5 13.5L15 7" stroke="#F2F7FF" strokeWidth="2" />
              </svg>
            </div>)}
          </>

        }
      </div>
      <div className={styles.summaryText}>
        <h3 className={styles.headerText}>{headerText}</h3>
        {summaryRichText ? (
          <RichTextParser document={summaryRichText} />
        ) : (
          <ReactMarkdown>{summaryText}</ReactMarkdown>
        )}
      </div>
    </div>
  )




}
export default connect(mapStateToProps, mapDispatchToProps)(ModulEachChecklist);